import React, { useEffect } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { X, ChevronLeft, ChevronRight } from "lucide-react";

export const Lightbox = ({ images, index, onClose, onNav }) => {
  useEffect(() => {
    const handler = (e) => {
      if (e.key === "Escape") onClose();
      if (e.key === "ArrowRight") onNav(1);
      if (e.key === "ArrowLeft") onNav(-1);
    };
    window.addEventListener("keydown", handler);
    return () => window.removeEventListener("keydown", handler);
  }, [onClose, onNav]);

  return (
    <AnimatePresence>
      {index !== null && (
        <motion.div
          initial={{ opacity: 0 }} animate={{ opacity: 1 }} exit={{ opacity: 0 }}
          className="fixed inset-0 z-[100] bg-black/95 flex items-center justify-center"
          data-testid="lightbox"
          onClick={onClose}
        >
          <button data-testid="lightbox-close" className="absolute top-6 right-6 text-white/70 hover:text-white transition-colors" onClick={onClose}>
            <X size={28} />
          </button>
          <button className="absolute left-6 text-white/70 hover:text-white transition-colors" onClick={(e) => { e.stopPropagation(); onNav(-1); }}>
            <ChevronLeft size={40} />
          </button>
          <motion.img
            key={index}
            initial={{ opacity: 0, scale: 0.96 }} animate={{ opacity: 1, scale: 1 }}
            transition={{ duration: 0.4 }}
            src={images[index]} alt="" className="max-h-[85vh] max-w-[90vw] object-contain"
            onClick={(e) => e.stopPropagation()}
          />
          <button className="absolute right-6 text-white/70 hover:text-white transition-colors" onClick={(e) => { e.stopPropagation(); onNav(1); }}>
            <ChevronRight size={40} />
          </button>
          <div className="absolute bottom-6 text-white/50 text-xs tracking-[0.2em] font-mono">
            {index + 1} / {images.length}
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default Lightbox;
